import { render, staticRenderFns } from "./RouterWrapperPage.vue?vue&type=template&id=29e27977"
import script from "./RouterWrapperPage.vue?vue&type=script&lang=js"
export * from "./RouterWrapperPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports